import React, { useState, useEffect } from 'react';
import { Skull, ArrowUpCircle, Package, CalendarX, AlertTriangle } from 'lucide-react';

function ExpiredTab({ token, activeShopId, setSelectedItem }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExpired = async () => {
    setLoading(true);
    try {
      const shopParam = activeShopId ? `?shopId=${activeShopId}` : "";
      const res = await fetch(`/api/expired-items${shopParam}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setItems(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const handleExport = async () => {
    try {
      const shopParam = activeShopId ? `?shopId=${activeShopId}` : "";
      const res = await fetch(`/api/expired-export${shopParam}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "muddati_otganlar_2022_plus.xlsx";
        a.click();
      }
    } catch (e) { alert("Eksportda xato"); }
  };

  useEffect(() => {
    fetchExpired();
  }, [activeShopId]);

  return (
    <div className="space-y-8 animate-in">
      <div className="bg-rose-500/10 border border-rose-500/20 p-8 rounded-[40px] flex items-center justify-between">
        <div className="flex items-center gap-6">
           <div className="w-16 h-16 bg-rose-500 rounded-3xl flex items-center justify-center text-white shadow-xl shadow-rose-900/30">
              <Skull size={32} />
           </div>
           <div>
              <h3 className="text-2xl font-black text-white italic">Mortalitet Nazorati</h3>
              <p className="text-rose-400 font-bold text-sm uppercase tracking-widest mt-1">Muddati tugaganiga 3 oydan oshgan tovarlar (2022+)</p>
           </div>
        </div>
        <button onClick={handleExport} className="bg-slate-900 border border-rose-500/30 text-rose-500 px-8 py-4 rounded-3xl font-black flex items-center gap-3 hover:bg-rose-500 hover:text-white transition-all shadow-lg active:scale-95">
           <ArrowUpCircle size={24}/> EXCELGA YUKLASH
        </button>
      </div>

      <div className="bg-slate-900 rounded-[50px] shadow-2xl border border-rose-500/10 overflow-hidden">
        <table className="w-full text-left">
          <thead>
            <tr className="text-[11px] font-black uppercase text-slate-500 bg-black/20">
              <th className="px-10 py-7 tracking-widest">Mahsulot</th>
              <th className="px-10 py-7 text-center tracking-widest">Yaroqlilik muddati</th>
              <th className="px-10 py-7 text-center tracking-widest">Holat</th>
              <th className="px-10 py-7 text-right tracking-widest">Tannarx</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {items.length === 0 && !loading && (
              <tr>
                <td colSpan="4" className="px-10 py-32 text-center text-slate-600 font-black text-2xl opacity-20">
                   TOZA: MUDDATI O'TGAN TOVARLAR TOPILMADI
                </td>
              </tr>
            )}
            {items.map((item, idx) => (
              <tr key={idx} className="hover:bg-rose-600/5 transition cursor-pointer group" onClick={() => setSelectedItem(item)}>
                <td className="px-10 py-8">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-2xl bg-slate-800 flex items-center justify-center text-slate-500 border border-white/5 group-hover:bg-rose-500/20 group-hover:text-rose-500 transition-colors">
                       <Package size={24}/>
                    </div>
                    <div>
                      <div className="font-black text-slate-100 text-lg">{item.product_name}</div>
                      <div className="text-[10px] font-mono text-slate-500 mt-1">{item.marking_code}</div>
                    </div>
                  </div>
                </td>
                <td className="px-10 py-8 text-center font-black text-rose-500 flex flex-col items-center">
                   <div className="flex items-center gap-2 text-lg">
                      <CalendarX size={18}/>
                      {new Date(item.expiry_date).toLocaleDateString()}
                   </div>
                   <span className="text-[9px] text-rose-800 uppercase tracking-tighter mt-1">
                      Xavfli zona (+3 oy o'tdi)
                   </span>
                </td>
                <td className="px-10 py-8 text-center">
                   <span className="px-4 py-2 rounded-full bg-rose-500/10 text-rose-500 border border-rose-500/20 text-[10px] font-black uppercase tracking-widest flex items-center gap-2 justify-center w-fit mx-auto">
                      <AlertTriangle size={12}/> MUSODARA QILINISHI MUMKIN
                   </span>
                </td>
                <td className="px-10 py-8 text-right font-black text-2xl text-white">
                   {Math.round(item.cost_price).toLocaleString()} <span className="text-xs text-slate-600 font-bold uppercase ml-1">sum</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ExpiredTab;
